import React, { PropsWithChildren, forwardRef } from 'react';

interface ContentProps extends PropsWithChildren<{}> {
	Breadcrumbs: React.ElementType;
	wrapperClass?: string;
	currPageName?: string;
	showSingleCrumb?: boolean;
}

export const Content = forwardRef<HTMLDivElement, ContentProps>(
	(
		{ children, Breadcrumbs, wrapperClass = '', currPageName, showSingleCrumb },
		ref,
	) => (
		<main className={`content-wrapper ${wrapperClass}`} ref={ref}>
			<Breadcrumbs
				currPageName={currPageName}
				showSingleCrumb={showSingleCrumb}
			/>
			{children}
		</main>
	),
);
